import type { Texts } from '../useTexts'

export const createValidateTerritoryFilter = (
  texts: Texts,
  territoryFilter: uui.domain.client.rm.Territory[],
  type: uui.domain.rm.RouteManagerUserType,
  limitedAccess: boolean,
) => {
  const hasError = limitedAccess && territoryFilter.length === 0 && type !== 'courier'

  const territoryFilterRequiredError = {
    id: 'territoryFilterRequiredError',
    message: texts.errors.territoryFilter,
    field: 'territoryFilter' as const,
    priority: 10,
  }

  return {
    [territoryFilterRequiredError.id]: hasError ? territoryFilterRequiredError : undefined,
  }
}
